import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';

import { CopilotFeaturesRow } from 'app/views/layout/views/settings/views/copilotTrial/components/copilotFeaturesRow/copilotFeaturesRow';
import { createAppModal } from 'utils/modal';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useCopilotTrial } from 'utils/useCopilotTrial';

import styles from './copilotTrialIntroModal.module.scss';

/**
 * Represents the modal for customers to provide feedback to Dixa from within
 * the app.
 */
export const CopilotTrialIntroModal = createAppModal(
  { type: 'app:copilotTrialIntro' },
  ({ isOpen, hide }): JSX.Element => {
    const { setDismissedIntroModal } = useCopilotTrial();
    const navigate = useAppNavigate();
    const handleClose = (): void => {
      setDismissedIntroModal();
      hide?.();
    };

    const gotoTrialPage = (): void => {
      navigate({ path: '/settings/copilot-trial' });
      setDismissedIntroModal();
      hide?.();
    };

    return (
      <Modal isOpen={isOpen} onClose={handleClose} className={styles.modal}>
        <ModalHead
          title={
            <>
              Introducing Agent Co-pilot:
              <br />
              Elevate Your Support Experience with AI!
            </>
          }
          onClose={handleClose}
        />

        <ModalBody>
          <Text.Paragraph>
            The Agent Co-pilot bundle equips you with AI-powered tools designed
            to simplify customer interactions. Say goodbye to time-consuming
            little tasks and hello to smoother conversations. Stay updated with
            the latest AI advancements, making your job easier and more
            efficient.
          </Text.Paragraph>

          <CopilotFeaturesRow showLearnMore={false} />

          <Text.Paragraph>
            Keen to explore Agent Copilot? Discover its capabilities and request
            your lead to activate the trial.
          </Text.Paragraph>
        </ModalBody>

        <ModalFoot confirmName="Learn more" confirmOnClick={gotoTrialPage} />
      </Modal>
    );
  },
);
